import React, { useState } from 'react'
import Icon from '../../../../../components/icon/Icon'
import iconsEnum from '../../../../../enums/iconsEnum'
import { CircularProgress, IconButton } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import { Releve } from '../account_model'
import { IntlShape, useIntl } from 'react-intl'
import { downloadOperationPDF } from '../accountMapper'

const useStyle = makeStyles((theme) => ({
    ...styles(theme),
    iconPdf: {
        fill: theme.palette.accessibility.main
    }
}))

interface AcceptingProps {
    operation: Releve
}

type PdfIconProps = AcceptingProps

const PdfIcon: React.FC<PdfIconProps> = (
    {
        operation
    }
) => {
    const classes = useStyle()
    const intl: IntlShape = useIntl()
    const [loadingDdl, setLoadingDdl] = useState<boolean>(false)

    return (
        <>
            {operation.exist_doc &&
            <IconButton
                onClick={() => downloadOperationPDF(operation, intl.locale, setLoadingDdl)}
                disabled={loadingDdl}
            >
                {loadingDdl ?
                    <CircularProgress size={24} />
                    :
                    <Icon size={24} icon={iconsEnum.Pdf} className={classes.iconPdf} />
                }
            </IconButton>
            }
        </>
    )
}

export default PdfIcon
